import client from './client';

export const getCounts = (params) =>
  client.get('/inventory-counts', { params }).then((r) => r.data);

export const getCount = (uuid) =>
  client.get(`/inventory-counts/${uuid}`).then((r) => r.data);

export const getCountItems = (uuid, page = 1, limit = 50, search, filter) =>
  client
    .get(`/inventory-counts/${uuid}/items`, {
      params: { page, limit, search, filter },
    })
    .then((r) => r.data);

export const lookupCountItem = (uuid, query) =>
  client
    .get(`/inventory-counts/${uuid}/items/lookup`, { params: { q: query } })
    .then((r) => r.data);

export const createCount = (data) =>
  client.post('/inventory-counts', data).then((r) => r.data);

export const startCount = (uuid) =>
  client.post(`/inventory-counts/${uuid}/start`).then((r) => r.data);

export const updateCountItem = (countUuid, productUuid, data) =>
  client
    .patch(`/inventory-counts/${countUuid}/items/${productUuid}`, data)
    .then((r) => r.data);

export const updateCountItems = (uuid, items) =>
  client
    .patch(`/inventory-counts/${uuid}/items`, { items })
    .then((r) => r.data);

export const completeCount = (uuid, data) =>
  client.post(`/inventory-counts/${uuid}/complete`, data).then((r) => r.data);

export const cancelCount = (uuid) =>
  client.post(`/inventory-counts/${uuid}/cancel`).then((r) => r.data);

export const deleteCount = (uuid) =>
  client.delete(`/inventory-counts/${uuid}`).then((r) => r.data);
